export default __webpack_public_path__ + "static/media/mobileScreen1.332d7e4d.png";